import { IconSize } from 'constants/coreDesignSystem';

export const ICON_SIZE = IconSize[20];
